var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 53,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M19.682 49.749a6.29 6.29 0 0 1-4.819-.614 6.48 6.48 0 0 1-3.006-3.882L3.24 14.287a6.48 6.48 0 0 1 .569-4.876 6.29 6.29 0 0 1 3.81-3.015L19.82 3l7.825 4.495L39.848 4.1a6.29 6.29 0 0 1 4.82.613 6.48 6.48 0 0 1 3.005 3.882l.862 3.097M19.682 49.749l42.71-11.887a6.29 6.29 0 0 0 3.81-3.015 6.48 6.48 0 0 0 .568-4.876l-4.309-15.483a6.48 6.48 0 0 0-3.006-3.882 6.29 6.29 0 0 0-4.819-.613l-30.507 8.49a6.29 6.29 0 0 0-3.81 3.015 6.48 6.48 0 0 0-.568 4.876l4.31 15.483a6.48 6.48 0 0 1-.569 4.877 6.29 6.29 0 0 1-3.81 3.014"
  })));
};
export default SvgFolder;